import type { CSSProperties } from 'react';
import { cn } from '@/shared/lib/cn';
import type { OverviewFact } from './objectOverviewModel';

/**
 * Faktenband (§6): eine umrahmte Fläche mit Dividern statt losgelöster Kacheln. Die Spaltenzahl
 * folgt den Fakten, die der Nutzer sehen darf; auf schmalen Flächen stehen je zwei nebeneinander.
 */
export function ObjectFactsBand({ facts }: { facts: OverviewFact[] }) {
  const odd = facts.length % 2 === 1;
  return (
    <dl
      aria-label="Kennzahlen"
      style={{ '--fact-cols': facts.length } as CSSProperties}
      className="bg-line/60 border-line shadow-card @2xl:grid-cols-[repeat(var(--fact-cols),minmax(0,1fr))] grid grid-cols-2 gap-px overflow-hidden rounded-lg border"
    >
      {facts.map((fact, index) => (
        <div
          key={fact.id}
          className={cn(
            'bg-card @2xl:px-5 @2xl:py-4 min-w-0 px-4 py-3.5',
            odd && index === 0 && '@2xl:col-span-1 col-span-2',
          )}
        >
          <dt className="text-ink-soft text-[10.5px] font-semibold uppercase tracking-[0.14em]">
            {fact.label}
          </dt>
          <dd className="text-ink mt-1 whitespace-nowrap font-serif text-2xl tabular-nums leading-tight">
            {fact.value}
            {fact.unit && <span className="text-ink-soft ml-1.5 text-sm">{fact.unit}</span>}
          </dd>
          <dd className="text-ink-soft mt-0.5 text-xs">{fact.detail}</dd>
        </div>
      ))}
    </dl>
  );
}
